import firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyArmrJiO0r5qXze1EMNHQbRG8qNIVqlons',
  authDomain: 'myportfolio-1dd08.firebaseapp.com',
  projectId: 'myportfolio-1dd08',
  storageBucket: 'myportfolio-1dd08.appspot.com',
  messagingSenderId: '608787042382',
  appId: '1:608787042382:web:3ef5650fc19cee0c42f31f'
}

const firebaseApp = firebase.initializeApp(config)

const db = firebaseApp.firestore()
const usersCollection = db.collection('users')

export const createUser = user => {
  return usersCollection.add(user)
}

export const getUser = async id => {
  const user = await usersCollection.doc(id).get()
  return user.exists ? user.data() : null
}

export const updateUser = (id, user) => {
  return usersCollection.doc(id).update(user)
}

export const deleteUser = id => {
  return usersCollection.doc(id).delete()
}
